import { DragHandle } from '@/components/custom/ogsm/drag-handle'
import { NodeHeading } from '@/components/custom/ogsm/node-heading'
import { TargetCell } from '@/components/custom/ogsm/target-cell'
import { useBoardEdit } from '@/features/ogsm/board-edit-context'
import { OGSM_COPY } from '@/features/ogsm/ogsm-labels'
import { useOgsmSortable } from '@/hooks/use-ogsm-sortable'
import { cn } from '@/lib/utils'
import type { OgsmBoardNode } from '@/types/api'

/** A strategy and its measure, sharing the band's strategy and measure columns. */
export function StrategyRow({ node }: { node: OgsmBoardNode }) {
  const { session } = useBoardEdit()
  const editable = session.structureEditable
  const { setNodeRef, style, isDragging, handle } = useOgsmSortable(
    node.id,
    !editable
  )
  return (
    <div
      ref={setNodeRef}
      style={style}
      className={cn(
        'grid grid-cols-1 border-t border-t-primary/5 sm:grid-cols-[minmax(0,1fr)_14rem] lg:col-span-2 lg:grid-cols-subgrid',
        // Opaque, so a taller node sliding over its siblings hides them.
        isDragging &&
          'relative z-10 bg-background bg-linear-to-b from-primary/5 to-primary/5'
      )}
    >
      <div className="min-w-0 px-3 py-3">
        <NodeHeading
          node={node}
          titleVariant="body"
          handle={
            editable ? (
              <DragHandle
                bindings={handle}
                tone="row"
                label={OGSM_COPY.reorder.handleLabel(
                  node.title.trim() || OGSM_COPY.untitled
                )}
                hint={OGSM_COPY.reorder.strategiesHint}
              />
            ) : undefined
          }
        />
      </div>
      <div className="min-w-0 border-primary/10 px-3 py-3 sm:border-l sm:text-right">
        <TargetCell
          node={node}
          emptyLabel={OGSM_COPY.noMeasure}
          layout="measure"
        />
      </div>
    </div>
  )
}
